export const blockIconsTravelAttractionsNew = (
	<span className='material-symbols-outlined'>attractions</span>
);
